module.exports = __webpack_public_path__ + "img/about-ch1-coresectors-inequality.7a52583f.svg";